import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./login.css";
import logo from "../../image/ayekart logo.png";
import AuthService from "../../services/auth.service";
import { useSelector, useDispatch } from "react-redux";
import { setToken } from "../../redux/tokenSlice";
import { useForm } from "react-hook-form";
import classnames from "classnames";
import toast, { Toaster } from "react-hot-toast";
// ----------------------------------------------------------------
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Wave from "react-wavify";
import loginImg from "../../Assets/Images/login-img.png";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href={() => false}>
        AyekartBiz
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

// -------------------------------------------------------

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [usercategory, setUserCategory] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  const token = useSelector((state) => state.token.token);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const initialValues = {
    email: "",
    password: "",
  };

  const Auth = async (e) => {
    try {
      const res = await axios.post("/workflow/api/user/login", {
        email: e.email,
        password: e.password,
        user_category: e.role,
      });
      if (res.data.status) {
        toast.success("Logged in Successful");
        localStorage.setItem("token", res.data.Authorization);
        localStorage.setItem("userInfo", JSON.stringify(res.data.name));
        localStorage.setItem(
          "user_detail",
          JSON.stringify(res.data.user_detail)
        );
        localStorage.setItem("IsDepartmentHead", res.data.is_department_head);
        localStorage.setItem("IsRm", res.data.is_rm);
        localStorage.setItem("IsSe", JSON.stringify(res.data.is_se));
        dispatch(setToken(res.data.Authorization));

        if(e.role==='Finance'){
          navigate({ pathname: "/ayekart-fintech/finance-grids" });
        }else{
          navigate({ pathname: "/ayekart-fintech/orders" });
        }

      } else {
        alert(res.data.message);
        toast.error(res.data.message);
      }
    } catch (error) {
      alert("Something Went Wrong");
      // toast.error("Something Went Wrong");
      if (error.response) {
        setMsg("Login", error.response.data.msg);
      }
    }
    const logout = () => {
      AuthService.logout();
    };
  };

  // --------------------------

  const history = useNavigate();
  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   const data = new FormData(event.currentTarget);
  //   const loginCreds = {
  //     email: data.get("email"),
  //     password: data.get("password"),
  //   };
  //   localStorage.setItem("login_creds", JSON.stringify(loginCreds));
  //   history("/");
  // };

  console.log(email);

  //  -------------------------------------------------

  return (
    // <div className="container-fluid d-flex justify-content-center pt-3">
    //   <div className="box-login">
    //     <div className="card rounded-5 shadow-lg mt-3">
    //       <div className="hero-body">
    //         <div className="container">
    //           <div className="columns is-centered">
    //             <form onSubmit={handleSubmit(Auth)} className="box">
    //               <img src={logo} width={"200px"} height={"110px"} />
    //               <br></br>
    //               <label className="label">Email</label>
    //               <div className="controls">
    //                 <input
    //                   type="email"
    //                   className={classnames("password-box", {
    //                     "is-invalid": errors.email,
    //                   })}
    //                   placeholder="Username"
    //                   {...register("email", {
    //                     required: "Email is required",
    //                     pattern: {
    //                       value:
    //                         /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    //                       message: "Please Enter valid E-mail address",
    //                     },
    //                   })}
    //                   // onChange={(e) => setEmail(e.target.value)}
    //                 />
    //                 {errors.email && (
    //                   <div className="invalid-feedback">
    //                     {errors.email.message}
    //                   </div>
    //                 )}
    //               </div>

    //               <label className="label">Select Role</label>
    //               <div className="controls">
    //                 <select
    //                   onChange={(e) => {
    //                     setUserCategory(e.target.value);
    //                   }}
    //                   className={classnames("password-box", {
    //                     "is-invalid": errors.role,
    //                   })}
    //                   id="role"
    //                   {...register("role", {
    //                     required: "Please select role",
    //                   })}
    //                 >
    //                   <option value="">--- Select Your role ---</option>
    //                   <option value="Finance">Finance</option>
    //                   <option value="Operations">Operations</option>
    //                   <option value="Super admin">Super admin</option>
    //                 </select>
    //                 {errors.role && (
    //                   <div className="invalid-feedback">
    //                     {errors.role.message}
    //                   </div>
    //                 )}
    //               </div>

    //               <div>
    //                 <label className="label">Password</label>
    //                 <div className="controls">
    //                   <input
    //                     type="password"
    //                     className={classnames("password-box", {
    //                       "is-invalid": errors.password,
    //                     })}
    //                     placeholder="******"
    //                     // value={password}
    //                     // onChange={(e) => setPassword(e.target.value)}
    //                     {...register("password", {
    //                       required: "password is required",
    //                       //   pattern: {
    //                       //     value: /(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/,
    //                       //     message: 'Password should be containing Uppercase, lowercase,number/specialCharacter and minimum 8 characters'
    //                       // }
    //                     })}
    //                   />
    //                   {errors.password && (
    //                     <div className="invalid-feedback">
    //                       {errors.password.message}
    //                     </div>
    //                   )}
    //                 </div>
    //               </div>
    //               <div className="field mt-3 mb-3">
    //                 <button className="login-button" type="submit">
    //                   Login
    //                 </button>
    //               </div>
    //             </form>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <Toaster />
    // </div>
    <>
      <div className="login-page">
        {/* <ThemeProvider theme={theme}> */}
        <div className="container pt-3">
          <div className="row">
            <div className="col col-sm-12 col-md-6 col-lg-6">
              <div className="img-wrapper">
                <img className="login-img border-0" src={loginImg} alt="" />
              </div>
            </div>
            <div className="col col-sm-12 col-md-6 col-lg-6 d-flex align-items-center">
              <Container
                // component="main"
                className="card-glass position-relative pt-3 "
                style={{ zIndex: 1 }}
                maxWidth="xs"
              >
                <CssBaseline />
                <Box
                  sx={{
                    alignItems: "center",
                  }}
                >
                  <div className="row mx-0 ">
                    <div className="col d-flex justify-content-center flex-column align-items-center">
                      <span
                        className="fs-4 fw-bold fw-times"
                        style={{ color: "#2C488F" }}
                      >
                        Welcome to Ayekart
                      </span>
                      <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
                        <LockOutlinedIcon />
                      </Avatar>
                      <Typography
                        component="h1"
                        variant="h5"
                        className="text-3B59A6"
                      >
                        Sign in
                      </Typography>
                    </div>
                  </div>
                  <form onSubmit={handleSubmit(Auth)}>
                    <Box
                      // component="form"
                      // onSubmit={handleSubmit}
                      // noValidate
                      autoComplete="off"
                      sx={{ mt: 1 }}
                    >
                      <div className="mb-3">
                        <div className="row mx-0 d-flex text-start">
                          <label className="form-label text-3B59A6 fs-5">
                            Email address
                          </label>{" "}
                        </div>

                        <input
                          type="email"
                          className={classnames("form-control email-field", {
                            "is-invalid": errors.email,
                          })}
                          placeholder="Username"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value:
                                /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                              message: "Please Enter valid E-mail address",
                            },
                          })}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="row mx-0 d-flex text-start">
                          <label className="label text-3B59A6 fs-5">
                            Select Role
                          </label>
                        </div>

                        <div className="controls">
                          <select
                            onChange={(e) => {
                              setUserCategory(e.target.value);
                            }}
                            className={classnames("password-box form-control", {
                              "is-invalid": errors.role,
                            })}
                            id="role"
                            {...register("role", {
                              required: "Please select role",
                            })}
                          >
                            <option value="">--- Select Your role ---</option>
                            <option value="Finance">Finance</option>
                            <option value="Operations">Operations</option>
                            <option value="Super admin">Super admin</option>
                          </select>
                          {errors.role && (
                            <div className="invalid-feedback">
                              {errors.role.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mb-3">
                        <div className="row mx-0 d-flex text-start">
                          <label
                            for="exampleInputPassword1"
                            className="form-label text-3B59A6 fs-5"
                          >
                            Password
                          </label>
                        </div>

                        <input
                          type="password"
                          className={classnames(
                            "password-box form-control password-field",
                            {
                              "is-invalid": errors.password,
                            }
                          )}
                          placeholder="******"
                          // value={password}
                          // onChange={(e) => setPassword(e.target.value)}
                          {...register("password", {
                            required: "password is required",
                            //   pattern: {
                            //     value: /(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/,
                            //     message: 'Password should be containing Uppercase, lowercase,number/specialCharacter and minimum 8 characters'
                            // }
                          })}
                        />
                        {errors.password && (
                          <div className="invalid-feedback">
                            {errors.password.message}
                          </div>
                        )}
                        {/* <div id="emailHelp" className="form-text">
                  We'll never share your details with anyone else.
                </div> */}
                      </div>

                      <div className="row mt-4 mb-3">
                        <div className="col pt-1">
                          <div className="text-center">
                            <button
                              // onClick={handleSubmit}
                              type="submit"
                              style={{ "--clr": "#1e9bff" }}
                              className="a-btn"
                            >
                              <span>Sign In</span> <i></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <Grid container>
                        <Grid item sm className="text-start">
                          <Link href="/" variant="body1">
                            Forgot password?
                          </Link>
                        </Grid>
                        <Grid item>
                          <Link href="/" variant="body1">
                            {" Sign Up"}
                          </Link>
                        </Grid>
                      </Grid>
                    </Box>
                  </form>
                </Box>
                <Copyright sx={{ mt: 2, mb: 4 }} />
              </Container>
            </div>
          </div>
        </div>

        <Wave
          fill="url(#gradient)"
          style={{ position: "fixed", bottom: 0, height: "30vh" }}
          options={{
            amplitude: 50,
          }}
        >
          <defs>
            <linearGradient id="gradient" gradientTransform="rotate(100)">
              <stop offset="10%" stopColor="#81d4fa" />
              <stop offset="90%" stopColor="#0288d1" />
            </linearGradient>
          </defs>
        </Wave>
        {/* </ThemeProvider> */}
      </div>
    </>
  );
};

export default Login;
